module.exports = __webpack_public_path__ + "img/order.c716c524.png";